export default angular.module('contartemx.preferencias.impuestos', [
    'contartemx',
    'ui.router',
    'ui.bootstrap',
    'loader'
])
.controller('ImpuestosCtrl', function ($scope, $state, $stateParams, callToWebService, mostrarNotificacion) {

        $scope.loading = true;
        callToWebService.postCall('ObtenerListadosDeImpuestos', {},
            function success(data){
                var Trasladados = data.Respuesta.Trasladados.Categorias;
                var Acreditados = data.Respuesta.Acreditados.Categorias;

                for(var i = 0; i < Trasladados.length; i++)
                {
                    switch(Trasladados[i].Nombre)
                    {
                        case 'IVA':
                            $scope.TrasIVA = angular.copy(Trasladados[i].Impuestos);
                        break;

                        case 'IEPS':
                            $scope.TrasIEPS = angular.copy(Trasladados[i].Impuestos);
                        break;

                        case 'Retencion':
                            $scope.TrasRetencion = angular.copy(Trasladados[i].Impuestos);
                        break;
                    }
                }

                for(var i = 0; i < Acreditados.length; i++)
                {
                    switch(Acreditados[i].Nombre)
                    {
                        case 'IVA':
                            $scope.AcreIVA = angular.copy(Acreditados[i].Impuestos);
                        break;

                        case 'IEPS':
                            $scope.AcreIEPS = angular.copy(Acreditados[i].Impuestos);
                        break;

                        case 'Retencion':
                            $scope.AcreRetencion = angular.copy(Acreditados[i].Impuestos);
                        break;
                    }
                }
                $scope.loading = false;
            },

            function error(data){
                $scope.loading = true;
            });

            $scope.saveChanges = function(){
            $scope.loadingMsg = 'Editando impuestos..';
            $scope.load = true;
            $scope.loading = true;
            var Trasladados = $scope.TrasIVA.concat($scope.TrasIEPS).concat($scope.TrasRetencion);
            var Acreditados = $scope.AcreIVA.concat($scope.AcreIEPS).concat($scope.AcreRetencion);

            callToWebService.postCall('EditarImpuestosDelContribuyente', {trasladados:{Impuestos:Trasladados}, acreditados:{Impuestos:Acreditados}},
                function success(data){
                    $scope.loading = false;
                    $scope.load = false;
                    if (data.Mensaje === "")
                        mostrarNotificacion.info("Impuestos editados");
                    else
                        mostrarNotificacion.info(data.Mensaje);

                    $scope.$emit('nextOnboardingStep', 'inicio.resumen.cert');

                },
                function error(data){
                    $scope.loading = false;
                    $scope.load = false;
                    mostrarNotificacion.error(data.Mensaje);
                });
            };
       
});
